import Icon from '@mdi/react'
import { mdiAlertOctagonOutline } from '@mdi/js'
import { Button } from '@/components/ui/button.jsx'
import { Link } from '@tanstack/react-router'
import useStore from '@/hooks/useStore.js'
import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'

const UncaughtError = ({ error, ...props }) => {
  const { routerStore } = useStore()

  useEffect(() => {
    console.error(error)
  }, [error])

  return (
    <div {...props} className="flex grow flex-col items-center justify-center gap-6 p-3">
      <Icon className="max-h-fit w-full max-w-32" path={mdiAlertOctagonOutline} size="100%" />

      <div className="text-center">
        <h1 className="text-2xl">An unexpected error has occurred</h1>
        <h2 className="mt-2 text-lg">
          The incident has been logged and it will be resolved as soon as possible
        </h2>
      </div>

      <div className="flex flex-wrap justify-center gap-3">
        <Button asChild className="grow">
          <Link reloadDocument to={routerStore.routes.index}>
            Go Home
          </Link>
        </Button>

        <Button className="grow" onClick={routerStore.reload} variant="outline">
          Reload
        </Button>
      </div>
    </div>
  )
}

export default observer(UncaughtError)
